import React from 'react';

interface InputFieldProps {
  label: string;
  id: string;
  value: string;
}

const InputField: React.FC<InputFieldProps> = ({ label, id, value }) => (
  
    <label className="input-label" htmlFor={id}>
      {label}
      <br />
      <input
        readOnly
        type="password"
        id={id}
        name={id}
        className="password"
        value={value}
      />
    </label>
  
);

export default InputField;
